import { camelCase } from '../util.js'
var works = [
  {
    title: 'TIM图片20190802091802',
    desc: 'TIM图片20190802091802',
    thumb: camelCase('cases-brand-zedriv-0'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-01')
    ]
  },
  {
    title: 'TIM图片20190802092753',
    desc: 'TIM图片20190802092753',
    thumb: camelCase('cases-brand-zedriv-1'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-11')
    ]
  },
  {
    title: 'TIM图片20190802092753',
    desc: 'TIM图片20190802092753',
    thumb: camelCase('cases-brand-zedriv-2'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-21')
    ]
  },
  {
    title: 'TIM图片20190802092753',
    desc: 'TIM图片20190802092753',
    thumb: camelCase('cases-brand-zedriv-3'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-31')
    ]
  },
  {
    title: 'TIM图片20190802092753',
    desc: 'TIM图片20190802092753',
    thumb: camelCase('cases-brand-zedriv-4'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-41')
    ]
  },
  {
    title: 'TIM图片20190802092753',
    desc: 'TIM图片20190802092753',
    thumb: camelCase('cases-brand-zedriv-5'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-51')
    ]
  },
  {
    title: 'TIM图片20190802092753',
    desc: 'TIM图片20190802092753',
    thumb: camelCase('cases-brand-zedriv-6'),
    zpic: [
      camelCase('cases-brand-zedriv-lazyload-61')
    ]
  }

]
export default {
  name: '国机智骏',
  logo: {
    default: camelCase('cases-brand-9'),
    active: camelCase('cases-brand-9-cover')
  },
  works
}
